var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4576 0C14.559 0 13.8305 0.737477 13.8305 1.64706V3.29412H8.13559C7.23697 3.29412 6.50847 4.03159 6.50847 4.94118V14H3.25424V8.23529C3.25424 7.32571 2.52574 6.58824 1.62712 6.58824C0.728499 6.58824 0 7.32571 0 8.23529V23.0588C0 23.9684 0.728499 24.7059 1.62712 24.7059C2.52574 24.7059 3.25424 23.9684 3.25424 23.0588V17.2941H6.50847V26.3529C6.50847 27.2625 7.23697 28 8.13559 28H37.4237C38.3223 28 39.0508 27.2625 39.0508 26.3529V17.2941H42.3051V24.7051C42.3051 24.7051 48 24.9821 48 15.6471C48 6.31198 42.3051 6.58904 42.3051 6.58904V14H39.0508V4.94118C39.0508 4.03159 38.3223 3.29412 37.4237 3.29412H31.7288V1.64706C31.7288 0.737477 31.0003 0 30.1017 0H15.4576ZM30.1017 8.23529C30.1017 7.32571 29.3732 6.58824 28.4746 6.58824H17.0847C16.1861 6.58824 15.4576 7.32571 15.4576 8.23529V11.5294C15.4576 12.439 16.1861 13.1765 17.0847 13.1765H28.4746C29.3732 13.1765 30.1017 12.439 30.1017 11.5294V8.23529Z",
    fill: "#C0BFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/Engine.9c16fe0267a50a7f3a917ccb55b32bf1.svg";
export { ForwardRef as ReactComponent };